import { Inject, Injectable } from "@angular/core";
import { SocketService } from "@karma-games/angular-devkit/src/lib/services/communication";
import { ToastService } from "@karma-games/angular-devkit/src/lib/modules/toast";
import { PopupService } from "@karma-games/angular-devkit/src/lib/modules/popup";
import { LoaderService } from "@karma-games/angular-devkit/src/lib/modules/loader";
import { FetchCurrentRoundStateUseCase } from "../core/round/domain/fetch-current-round-state.use-case";
import { ConnectionStateHandlerService, CURRENT_NAMESPACE_TOKEN } from "@karma-games/angular-devkit/src/lib/services/connection-state-handler";
import { GetWalletUseCase } from "@karma-games/angular-devkit/src/lib/modules/user";
import { RefetchBetRecordsUseCase } from "../statistics-panel/domain/refetch-bet-records-use-case.service";
import { Subject, takeUntil } from "rxjs";
import { ErrorPageService } from "../error-page/error-page.service";
import { ExactDatePipe } from "@karma-games/angular-devkit/src/lib/modules/pipes";

@Injectable()
export class LobbyConnectionStateHandlerService extends ConnectionStateHandlerService {
    public onReconnect$: Subject<void> = new Subject();
    constructor(
        socket: SocketService,
        @Inject(CURRENT_NAMESPACE_TOKEN) currentNamespace: string,
        toast: ToastService,
        popup: PopupService,
        loader: LoaderService,
        datePipe: ExactDatePipe,
        private fetchCurrentRoundStateUseCase: FetchCurrentRoundStateUseCase,
        private getWalletUseCase: GetWalletUseCase,
        private refetchBetRecordsUseCase: RefetchBetRecordsUseCase,
        private errorPageService: ErrorPageService
    ) {
        super(socket, currentNamespace, toast, popup, datePipe, loader);
        this.namespace?.once("banned").pipe(takeUntil(this.destroy$)).subscribe(this.onBanned.bind(this));
    }

    override async onReconnect(): Promise<void> {
        super.onReconnect();
        this.fetchCurrentRoundStateUseCase.execute().catch(e => console.error(e));
        try {
            await this.getWalletUseCase.execute();
        } catch (e) {
            console.error(e);
        }
        this.refetchBetRecordsUseCase.execute();
        this.onReconnect$.next();
    }

    private onBanned(): void {
        this.errorPageService.showErrorPage({
            errorText: "ERROR_BANNED"
        });
    }
}
